import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {IBetClusterWin} from "../../server/TheBorderData";
import {TheBorder} from "../../TheBorder";
import {TheBorderSymbol} from "../../reels/TheBorderSymbol";
import {TheBorderStatics} from "../../TheBorderStatics";
import {TimelineLite} from "gsap";
import {TheBorderXNudgeView} from "../../view/TheBorderXNudgeView";
import {IClusterData, TheBorderUtils} from "../../utils/TheBorderUtils";

export class TheBorderXClusterRunner implements SimplePresentation {
    private _uniqueSymbols: string[] = [];

    public shouldRun(): boolean {
        const betClusterWins: IBetClusterWin[] = TheBorder.model.betClusterWins;
        let uniqueNames: string[] = [];

        if (betClusterWins.length === 0) {
            return false;
        }

        for (let i: number = 1; i < betClusterWins.length; i++) {
            if (uniqueNames.indexOf(betClusterWins[i].symbol) === -1) {
                uniqueNames.push(betClusterWins[i].symbol);
            }
        }

        const firstSymName: string = betClusterWins[0].symbol,
            idxOf1stSym: number = (uniqueNames.indexOf(firstSymName));
        if (idxOf1stSym > -1) {
            uniqueNames.splice(idxOf1stSym, 1);
        }

        this._uniqueSymbols = uniqueNames;

        return (uniqueNames.length > 1 || (uniqueNames.length === 1 && uniqueNames[0] !== firstSymName));
    }

    public start(controller: SimplePresentationRunnerController): void {
        const allClusters: Set<string>[] = [],
            checkedSymArr: string[] = [],
            tl: TimelineLite = new TimelineLite(),
            duration: number = 0.1,
            reels: string[][] = TheBorderXNudgeView.getReelsData();
        let time: number;

        tl.add(() => {
            controller.setSkipCallback(() => this.skip(tl));
        }, 0.1);

        this._uniqueSymbols.forEach((symName: string) => {
            const clusters: IClusterData[] = TheBorderUtils.getClustersForSymbol(reels, symName, checkedSymArr);
            let accumulatedClusters: Set<string> = clusters[0].info;

            for (let i: number = 1; i < clusters.length; i++) {
                clusters[i].info.forEach((val: string) => {
                    accumulatedClusters.add(val);
                });
            }
            allClusters.push(accumulatedClusters);
        });

        allClusters.forEach((val: Set<string>) => {
            time = tl.totalDuration();
            for (let reel: number = 0; reel < reels.length; reel++) {
                for (let row: number = 0; row < reels[reel].length; row++) {
                    if (!val.has(reel + "_" + row)) {
                        tl.add((TheBorder.allReelsView.getSymbolAtPosition(reel, row) as TheBorderSymbol).getNoWinAnimation(duration), time);
                    }
                }
            }
            if (val.size) {
                const firstValue: string[] = val.values().next().value.split("_"),
                    sym: TheBorderSymbol = (TheBorder.allReelsView.getSymbolAtPosition(+firstValue[0], +firstValue[1]) as TheBorderSymbol),
                    xPos: number = sym.position.x + (TheBorderStatics.reelPositions[+firstValue[0]].x),
                    yPos: number = sym.position.y - (sym.sizeMultiplier === 0.5 ? 50 : 0);
                let swoosh: TimelineLite;

                tl.add(swoosh = TheBorder.swooshAnimation.playSwoosh(xPos, yPos, 610, -84), (duration + time));
                tl.add(() => {
                    TheBorder.winMultiplierView.addToWinMultiplier(1);
                }, (duration + swoosh.totalDuration() + time));

                tl.to(this, {
                    duration: 0.2
                }, (duration + swoosh.totalDuration() + time));

                time = tl.totalDuration();
                for (let reel: number = 0; reel < reels.length; reel++) {
                    for (let row: number = 0; row < reels[reel].length; row++) {
                        tl.add((TheBorder.allReelsView.getSymbolAtPosition(reel, row) as TheBorderSymbol).getNoWinEndAnimation(), time);
                    }
                }

                tl.to(this, {
                    duration: 0.3
                });
            }
        });

        tl.add(() => {
            controller.finish();

            controller.setSkipCallback();
        });
    }

    private skip(tl: TimelineLite): void {
        tl.totalProgress(1);
    }
}